export default class ContentContext {
  constructor(name, image, id, type, group, options, parent_id) {
    this.name = name;
    this.image = image;
    this.id = id;
    this.type = type;
    this.group = group;
    this.options = options;
    this.parent_id = parent_id;
  }

  clone() {
    return new ContentContext(this.name, this.image, this.id, this.type, this.group, this.options, this.parent_id);
  }

  getName() {
    return this.name;
  }

  getImage() {
    return this.image;
  }

  getType() {
    return this.type;
  }

  getId() {
    return this.id;
  }

  getGroup() {
    return this.group;
  }

  getOptions() {
    return this.options;
  }

  getParentId() {
    return this.parent_id;
  }
}
